import axios from 'axios'

export default async function fetchLicenseStats(organizationSlug, callback) {
    return axios.get(`/${organizationSlug}/licenses/usage`).then(({ data }) => {
        callback(data.purchased, data.used, data.cap)
    })
}
